
export function CheckIcon(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
		<path d="M4.20262 7.95631L1.05004 4.8089L0.000900951 5.85976L4.20435 10.0563L13.197 1.04892L12.1461 -0.000218566L4.20262 7.95631Z" fill="white" />
	</svg>);
}